import { MoneyPurchaseAnnualAllowanceSource } from "../../../../../../Wrap/Constants/Enums/Apply/MoneyPurchaseAnnualAllowanceSource";
import { BankAccountOwner } from "../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { DepositMethod } from "../../../../../../Wrap/Constants/Enums/Domain/DepositMethod";
import { AccountAdviceType } from "../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { PensionType } from "../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SippDrawdownType } from "../../../../../../Wrap/Constants/Enums/Domain/SippDrawdownType";
import { RegularDepositMethod } from "../../../../../../Wrap/Constants/Enums/Domain/RegularDepositMethod";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WithdrawalMethod } from "../../../../../../Wrap/Constants/Enums/Domain/WithdrawalMethod";
import { ExternalIsaContributionType } from "../../../../../../Wrap/Constants/Enums/Transfer/ExternalIsaContributionType";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../../Shared/Entities/Constants/DateConstants";
import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { SourceType } from "../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { PaymentMethod } from "../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";
import { FrequencyType } from "../../../../../../Wrap/Constants/Enums/Domain/FrequencyType";

export enum processTypeEnum {
    Quote,
    NewBusiness,
    SinglePaymentTransfer,
    RegularPayment,
    topUpWithITFLS,
    GadReview,
    NewBusinessExistingClient,
    NewQuoteExistingClient,
    TakePensionBenefits,
    EditIncomePayments,
}

export const ContinueArrays = [];

export const ContinueArraysMap = {
    [Frequency.Monthly]: "Until Notified",
    [Frequency.Quarterly]: "Until Date",
};

export const ExternalIsaContributionTypeMap = {
    [ExternalIsaContributionType.CurrentTaxYear]: "Current",
    [ExternalIsaContributionType.PreviousTaxYear]: "Non-Current",
    [ExternalIsaContributionType.PreviousAndCurrentTaxYear]: "Both",
};

export enum PaymentType {
    Client = "Client",
    ThirdParty = "Third-party",
    Employer = "Employer",
}

export const TransferInModelMap = {
    [SubAccountType.Sipp]: "PensionTransfers",
    [SubAccountType.Npr]: "PensionTransfers",
    [SubAccountType.StocksIsa]: "IsaTransfers",
    [SubAccountType.InvestmentAccount]: "GiaTransfers",
};

export const BankAccountOwnerPaymentTypeMap = {
    [BankAccountOwner.Individual]: [PaymentType.Client],
    [BankAccountOwner.Joint]: [PaymentType.Client],
    [BankAccountOwner.Partner]: [PaymentType.Client],
    [BankAccountOwner.Employer]: [PaymentType.Employer, PaymentType.Client],
    [BankAccountOwner.ThirdParty]: [PaymentType.ThirdParty],
    [BankAccountOwner.Trust]: [PaymentType.Client],
    [BankAccountOwner.Client1]: [PaymentType.Client],
    [BankAccountOwner.Client2]: [PaymentType.Client],
};

export const PayeeType = {
    Client: PaymentType.Client,
    ThirdParty: PaymentType.ThirdParty,
    Employer: PaymentType.Employer,
};

export const datePickerOptions = {
    showYearDropdown: true,
    todayButton: ContentDatePicker.Today,
    isClearable: true,
    dateFormat: ContentDatePicker.DateFormat,
    acceptDateFormats: ACCEPT_DATE_FORMATS,
    alwaysValidateOnUpdate: false,
};

export const depositMethodArrays = [
    DepositMethod.Cheque,
    DepositMethod.DirectCredit,
    DepositMethod.DirectDebit,
    DepositMethod.WrapCash,
];
export const depositMethodArraysMap = {
    [DepositMethod.Cheque]: "Cheque",
    [DepositMethod.DirectCredit]: "Direct Credit",
    [DepositMethod.DirectDebit]: "Direct Debit",
    [DepositMethod.WrapCash]: "Cash Account",
};

export const batchTypeArrays = [BatchType.OneOff, BatchType.Standing];
export const batchTypeArraysMap = {
    [BatchType.OneOff]: "One-off",
    [BatchType.Standing]: "Standing",
    [BatchType.Auto]: "Auto",
};

export const OrderFrequencyTypeArrays = [
    Frequency.Fortnightly,
    Frequency.Monthly,
    Frequency.Quarterly,
    Frequency.HalfYearly,
    Frequency.Yearly,
];

export const OrderFrequencyArraysMap = {
    [Frequency.Fortnightly]: "Fortnightly",
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half Yearly",
    [Frequency.Yearly]: "Yearly",
};

export const regularDepositMethodArrays = [
    RegularDepositMethod.Cheque,
    RegularDepositMethod.BACS,
    RegularDepositMethod.DirectDebit,
    RegularDepositMethod.ProductWrapperCash,
];

export const regularDepositMethodArraysMap = {
    [RegularDepositMethod.Cheque]: "Cheque",
    [RegularDepositMethod.BACS]: "BACS",
    [RegularDepositMethod.DirectDebit]: "Direct Debit",
    [RegularDepositMethod.ProductWrapperCash]: "Cash Account",
    [RegularDepositMethod.DirectCredit]: "Direct Credit",
    [RegularDepositMethod.CHAPS]: "CHAPS",
    [RegularDepositMethod.Faster]: "Faster",
    [RegularDepositMethod.CashSubAccount]: "Product Cash",
    [RegularDepositMethod.SpecifiedSubAccount]: "Specified Sub Account",
};

export const daysUntilFirstPaymentDate = 20;

export const MoneyPurchaseAnnualAllowanceSourceArray = [
    MoneyPurchaseAnnualAllowanceSource.NotSpecified,
    MoneyPurchaseAnnualAllowanceSource.UncrystallisedFundsPcls,
    MoneyPurchaseAnnualAllowanceSource.StandaloneLumpSum,
    MoneyPurchaseAnnualAllowanceSource.FlexiAccessIncomePayment,
];

export const MoneyPurchaseAnnualAllowanceSourceArrayMap = {
    [MoneyPurchaseAnnualAllowanceSource.NotSpecified]: "Unknown",
    [MoneyPurchaseAnnualAllowanceSource.UncrystallisedFundsPcls]: "Uncrystallised pension saving lump sum payment",
    [MoneyPurchaseAnnualAllowanceSource.StandaloneLumpSum]: "Standalone lump sum payment",
    [MoneyPurchaseAnnualAllowanceSource.FlexiAccessIncomePayment]: "Flexi-access drawdown payment",
};

export const WithdrawalMethodArray = [WithdrawalMethod.TransferToWrapCash, WithdrawalMethod.BankAccount];

export const WithdrawalMethodMap = {
    [WithdrawalMethod.TransferToWrapCash]: "Transfer to Wrap cash",
    [WithdrawalMethod.BankAccount]: "Transfer to nominated Bank account",
};

export const FrequencyTypeArrays = [Frequency.Monthly, Frequency.Quarterly, Frequency.HalfYearly, Frequency.Yearly];

export const FrequencyArraysMap = {
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half yearly",
    [Frequency.Yearly]: "Yearly",
};

export const FrequencyTypeArraysMaps = {
    [FrequencyType.NotSpecified]: "Not specified",
    [FrequencyType.Daily]: "Daily",
    [FrequencyType.Weekly]: "Weekly",
    [FrequencyType.Monthly]: "Monthly",
    [FrequencyType.Quarterly]: "Quarterly",
    [FrequencyType.HalfYearly]: "Half yearly",
    [FrequencyType.Yearly]: "Yearly",
    [FrequencyType.Fortnightly]: "Fortnightly",
    [FrequencyType.Termly]: "Termly",
};

export const AdviceTypeArrays = [AccountAdviceType.NonDiscretionary, AccountAdviceType.Discretionary];

export const AdviceTypeArraysMap = {
    [AccountAdviceType.NonDiscretionary]: "Non-discretionary",
    [AccountAdviceType.Discretionary]: "Discretionary",
};

export const TransferKeysMap = {
    [SubAccountType.PersonalPortfolio]: "GiaTransfers",
    [SubAccountType.Sipp]: "PensionTransfers",
    [SubAccountType.StocksIsa]: "IsaTransfers",
};

export const CertificatedSharesAndEquityText =
    "If a combination of certificated investments and non certificated investments –" +
    "then a separate transfer must be submitted for each.Please ensure that the certificated" +
    " numbers are provided below. Once the transfer is completed the shares will be held electronically";

export const RegisteredOwnersText =
    "The Name(s) of the registered holder(s) must be given in full as recorded by the custodian These" +
    " ownership details can be amended as required";
export const ConductBusinessAuthorisedQuestionText = "Are you appropriately authorised to conduct this business?";
export const AdviceGivenQuestionText = "Did you give financial advice?";
export const MpaaQuestionText = "Is your client subject to the Money Purchase Annual Allowance (MPAA)?";

export const DpcQuestionText = "Are transfers subject to disqualifying pension credits?";

export const PaymentMethodTypeOptions = [PaymentMethod.Faster, PaymentMethod.Chaps];

export const PaymentMethodArraysMap = {
    [PaymentMethod.Chaps]: "CHAPS",
    [PaymentMethod.Faster]: "Faster",
};

export const PensionTypesArray = [
    PensionType.None,
    PensionType.TakePensionBenefits,
    PensionType.ImmediateTaxFreeLumpSum,
];

export const PensionTypesMap = {
    [PensionType.None]: "None",
    [PensionType.TakePensionBenefits]: "Take pension benefits",
    [PensionType.ImmediateTaxFreeLumpSum]: "Immediate tax-free lump sum",
};

export const RegularIncomePaymentAlertMsg = {
    Frenquency: "Please update this frequency on the drawdown step",
    FirstPaymentDate:
        "Changing the payment date will amend the payment date across all pension arrangements and any regular crystallisation schedules",
    EndDate: "No further payments will be made after the date entered in this field",
};

export const SourceTypeArray = [SourceType.ProductCash, SourceType.WrapCash];

export const SourceTypeMap = {
    [SourceType.ProductCash]: "Product cash",
    [SourceType.WrapCash]: "Wrap cash",
};

export const DrawdownTypeOptions = [SippDrawdownType.Flexible, SippDrawdownType.No, SippDrawdownType.Capped];

export const DrawdownTypeOptionsMap = {
    [SippDrawdownType.Flexible]: "Flexi-access single",
    [SippDrawdownType.No]: "Regular crystallisation",
    [SippDrawdownType.Capped]: "Capped single",
};

export const CrystallisationOptions = ["Full", "Partial"];

export const crystallisationAmountErrorMessage = {
    valueToCrystalliseIsZero:
        "The value available to crystallise is zero so you cannot complete the crystallisation at this time.",
    inputIsZeroAndLessThanUncrystallised:
        "Please enter a crystallisation amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputIsZeroAndEqualUncrystallised:
        "Please enter a crystallisation amount that is greater than zero and less than the value available to crystallise.",
    inputEqualValueToCrystallise:
        'The amount you have entered is equal to the total value available to crystallise. If you want to crystallise the whole amount, please choose "Full" for your crystallisation options.',
    inputGreaterThanValueToCrystalliseAndLessThanUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a crystallisation amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputGreaterThanValueToCrystalliseAndEqualUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a crystallisation amount that is greater than zero and less than the value available to crystallise.",
};

export const drawdownDetailsMessage = {
    crystallisationOptionErrorMessage:
        "You will need to cancel the process because the client has entitlements that require this to be a full crystallisation, but the value available to crystallise is less than the uncrystallised fund value.",
    LTAInputErrorMessage:
        "Please enter a value for the LTA crystallised off platform that is equal to or greater than 0%",
    regularCrystallisationAmountErrorMessage: "Please enter an amount that is greater than zero",
};

export const LTADetailHeading = {
    previousLTA: "Lifetime allowance (LTA) previously used in this account",
    LTABefore2006: "LTA used by benefits that commenced before 6 April 2006",
    availableLTA: "Available LTA",
    otherLTA: "Other LTA used you need to tell us about",
    LTAByThisCrystallisation: "LTA % used by this crystallisation",
    LTAInTotal: "LTA % used in total following this crystallisation",
    crystallisationAmountSubjectToLTAExcessCharge: "Amount of crystallisation subject to LTA excess charge",
    estimateLTAForInitialCrystallisation: "Estimated LTA % usage for initial crystallisation",
    estimateLTAPerRegularCrystallisation: "Estimated LTA % usage per regular crystallisation",
    estimateAvailableLTAInAYear: "Estimated available LTA after a year",
    estimateLTAUsedInAYear: "Estimated LTA that will be used after a year",
    estimateTotalLTAUsedInAYear: "Estimated total LTA that will be used after a year",
    estimatedChargeableCrystallisation: "Estimated chargeable portion of crystallisation after a year",
    crystallisationChargeablePortion: "Chargeable portion of crystallisation",
};

export const LTADetailTooltiopMessage = {
    previousLTA: "TBC by Pension pod/SL props",
    otherLTA: "TBC by Pension pod/SL props",
    LTAByThisCrystallisation:
        "This is the percentage of the lifetime allowance for the current tax year that will be used by your client's crystallisation.",
    LTAInTotal:
        "This is the total lifetime allowance for the current tax year that will be used once this crystallisation is added to any previous crystallisations taken by your client.",
    estimatedChargeableCrystallisation:
        "This is the estimated amount that we will crystallise in order to achieve the required income",
};
